<template>
  <div>
    <header-title title="Perfil" />
    <div class="shadow_box rounded-lg p-6">
      <h1 class="mb-6 text-2xl uppercase text-gray-777 font-roboto">Perfil</h1>
      <form @submit.prevent="update">
        <div class="flex flex-wrap mb-4 px-4">
          <photo-input v-model="form.photo" :error="form.errors[`photo.upload`]" class="pb-8 lg:pr-6 w-full lg:w-1/2 max-w-[350px]" type="file" label="Foto" />
          <div class="pb-8 hidden lg:block lg:w-1/2" />

          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 lg:pr-6 w-full lg:w-1/2" label="Nome" />
          <mask-input v-if="user.role === 2" v-model="form.professional.cpf" mask="###.###.###-##" :error="form.errors[`professional.cpf`]" class="pb-8 w-full lg:pr-6 lg:w-1/4" label="CPF" />
          <mask-input v-if="user.role === 2" v-model="form.professional.cnpj" mask="##.###.###/####-##" :error="form.errors[`professional.cnpj`]" class="pb-8 w-full lg:w-1/4" label="CNPJ" />

          <email-input v-model="form.email" :error="form.errors.email" class="pb-8 lg:pr-6 w-full lg:w-1/2" label="E-mail" />
          <select-input v-if="user.role === 2" v-model="form.professional.sex" :error="form.errors[`professional.sex`]" class="pb-8 w-full lg:w-1/2" label="Gênero">
            <option :value="null" />
            <option v-for="(value, name) in sex_options" :key="name" :value="name">{{ value }}</option>
          </select-input>

          <date-input v-if="user.role === 2" v-model="form.professional.birthdate" :error="form.errors[`professional.birthdate`]" class="pb-8 w-full lg:w-1/2 lg:pr-6" label="Data de Nascimento" />
          <mask-input v-if="user.role === 2" v-model="form.professional.phone_mobile" :mask="['(##) #####-####']" :clear-incomplete="true" :error="form.errors[`professional.phone_mobile`]" class="pb-8 w-full lg:w-1/2" label="Celular" />

          <select-input v-if="user.role === 2" v-model="form.professional.class_entity" :error="form.errors[`professional.class_entity`]" class="pb-8 lg:pr-6 w-full lg:w-1/3" label="Conselho profissional">
            <option :value="null" />
            <option v-for="(value, name) in class_entity_options" :key="name" :value="name">{{ value }}</option>
          </select-input>
          <text-input v-if="user.role === 2" v-model="form.professional.class_number" :error="form.errors[`professional.class_number`]" class="pb-8 lg:pr-6 w-full lg:w-1/3" label="Número do órgão" />
          <select-input v-if="user.role === 2" v-model="form.professional.uf" :error="form.errors[`professional.uf`]" class="pb-8 w-full lg:w-1/3" label="UF">
            <option :value="null" />
            <option v-for="(value, name) in states_options" :key="name" :value="name">{{ value }}</option>
          </select-input>

          <textarea-input
            v-if="user.role === 2"
            v-model="form.professional.about"
            :error="form.errors[`professional.about`]"
            class="pb-8 w-full" minheight="260px"
            label="Sobre"
          />

          <div v-if="user.role === 2" class="w-full">
            <switch-input
              v-model="form.professional.notification_whatsapp"
              label="Receber mensagens atraves do whatsapp"
              label-checked="Sim"
              label-unchecked="Não"
              class="mt-4 mb-6"
            />
          </div>

          <vue-select-input v-if="user.role === 2" v-model="form.specialties" :multiple="true" :options="specialties" :error="form.errors.specialties" class="pb-8 lg:pr-6 w-full lg:w-1/2" label="Especialidades" text="nenhuma especialidade encontrada" />
          <div v-if="!form.specialties.length" class="mt-6 hidden lg:block lg:w-1/2" />
          <div v-if="user.role === 2 && form.specialties.length" class="pb-8 flex flex-col text-center w-full lg:w-1/2">
            <div class="flex flex-nowrap bg-gray-100/50 p-4">
              <div class="w-full lg:w-1/2">Especialidade</div>
              <div class="w-full lg:w-1/2">RQE</div>
            </div>
            <div v-for="(specialty, specialty_index) in form.specialties" :key="specialty_index" class="flex flex-nowrap px-4 py-2">
              <div class="w-full lg:w-1/2">{{ specialty.name }}</div>
              <div class="w-full lg:w-1/2">
                <text-input v-model="specialty.rqe" :error="form.errors[`specialties.`+specialty_index+`.rqe`]" class="w-full" />
              </div>
            </div>
          </div>
          <button v-if="!changePassword" type="button" class="btn-primary font-normal text-xs px-6 py-2.5" @click="changePassword = true"><font-awesome-icon icon="fa-lock" class="mr-2" /> Alterar senha</button>
          <password-input v-if="changePassword" v-model="form.password" :error="form.errors.password" class="pb-8 lg:pr-6 w-full lg:w-1/2" label="Nova senha" />
          <password-input v-if="changePassword" v-model="form.password_confirmation" :error="form.errors.password_confirmation" class="pb-8 w-full lg:w-1/2" label="Confirme a nova senha" />

          <div v-if="user.role === 2" class="w-full">
            <div v-for="(address, address_index) in form.professional.addresses" :key="address_index" class="w-full flex flex-wrap p-6 mt-4 bg-gray-100/50 relative">
              <cep-input v-model="address.postcode" :error="form.errors[`professional.addresses.`+address_index+`.postcode`]" class="lg:pr-6 w-5/6 lg:w-5/12" placeholder="CEP" @update-address="(...args) => onUpdateAddress(address,...args)" />
              <text-input v-model="address.street" :error="form.errors[`professional.addresses.`+address_index+`.street`]" class="mt-6 lg:mt-0 w-full lg:w-6/12" placeholder="Logradouro" />

              <div class="absolute lg:relative z-10 lg:top-0 top-9 lg:right-4 right-4 w-1/6 lg:w-1/12 self-center text-right">
                <span @click="deleteAddress(form.professional, address)"><font-awesome-icon icon="fa-xmark" class="text-gray-600 text-lg cursor-pointer" /></span>
              </div>

              <text-input v-model="address.number" :error="form.errors[`professional.addresses.`+address_index+`.number`]" class="mt-6 lg:pr-6 w-full lg:w-1/3" placeholder="Número" />
              <text-input v-model="address.complement" :error="form.errors[`professional.addresses.`+address_index+`.complement`]" class="mt-6 w-full lg:w-2/3" placeholder="Complemento" />
              <text-input v-model="address.neighborhood" :error="form.errors[`professional.addresses.`+address_index+`.neighborhood`]" class="mt-6 lg:pr-6 w-full lg:w-1/3" placeholder="Bairro" />
              <text-input v-model="address.city" :error="form.errors[`professional.addresses.`+address_index+`.city`]" class="mt-6 lg:pr-6 w-full lg:w-1/3" placeholder="Cidade" />
              <select-input v-model="address.state" :error="form.errors[`professional.addresses.`+address_index+`.state`]" class="mt-6 w-full lg:w-1/3" placeholder="Estado">
                <option :value="null" disabled class="hidden invisible">Estado</option>
                <option v-for="(value, name) in states_options" :key="name" :value="name">{{ value }}</option>
              </select-input>
              <text-input v-model="address.cnes" :error="form.errors[`professional.addresses.`+address_index+`.cnes`]" class="mt-6 lg:pr-6 w-full lg:w-1/2" placeholder="CNES" />
              <mask-input v-model="address.phone" :mask="['(##) ####-####', '(##) #####-####']" :clear-incomplete="true" :error="form.errors[`professional.addresses.`+address_index+`.phone`]" class="mt-6 w-full lg:w-1/2" placeholder="Telefone" />
            </div>
            <button class="btn-primary mt-6 flex items-end font-roboto font-normal text-xs px-6 py-2.5" @click.prevent="form.professional.addresses.push({state: null});">
              <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /> Adicionar Endereço
            </button>
            <div v-if="form.errors[`professional.addresses`]" class="form-error">{{ form.errors[`professional.addresses`] }}</div>
          </div>
        </div>

        <div v-if="user.role === 2" class="w-full px-4">
          <p class="text-base font-normal font-poppins">Diplomas (opcional)</p>

          <ul class="my-10 flex flex-wrap gap-4">
            <li v-for="certificate in userCertificates" :key="certificate.id">
              <img :src="certificate.url" alt="imagem do certificado" class="w-[217px] h-[165px]" />
              <p class="text-xs font-poppins mt-3 text-primary text-center">
                {{ certificate.name }}
                <button type="button" class="ml-2 text-red-500" @click="deleteCertificate( certificate.id )">
                  <font-awesome-icon icon="fa-x" />
                </button>
              </p>
            </li>
          </ul>

          <ul class="my-10">
            <li v-for="(file, index) in form.certificates" :key="index" class="max-w-[350px]">
              <font-awesome-icon icon="fa-file" class="mr-2" />
              {{ file.name }}

              <button type="button" class="mr-2" @click="handleRemoveUpload(index)">
                <font-awesome-icon icon="fa-x" />
              </button>
            </li>
          </ul>

          <input id="certificates" type="file" class="hidden" accept="image/*,.pdf" @change="handleUploadPdf" />

          <label for="certificates" class="bg-primary px-4 py-2 rounded-md text-white font-poppins text-sm">
            <font-awesome-icon icon="fa-arrow-up-from-bracket" />
            Enviar Arquivo
          </label>
        </div>

        <div class="mt-10">
          <loading-button :loading="form.processing" class="btn-primary" type="submit">Salvar</loading-button>
        </div>
      </form>
    </div>
  </div>

  <exit-without-modal
    ref="confirmExitModal"
    @accept-exit="handlerAcceptExitOnPage"
    @deny-exit="handlerDenyExitOnPage" />
</template>

<script>
import { computed } from 'vue'
import { router } from '@inertiajs/vue3'
import { Head as HeaderTitle, useForm, usePage } from '@inertiajs/inertia-vue3'

import Layout from '@/Shared/Layout/Layout'
import TextInput from '@/Shared/Fields/TextInput'
import PasswordInput from '@/Shared/Fields/PasswordInput'
import SelectInput from '@/Shared/Fields/SelectInput'
import LoadingButton from '@/Shared/Components/LoadingButton'
import MaskInput from '@/Shared/Fields/MaskInput'
import PhotoInput from '@/Shared/Fields/PhotoInput'
import VueSelectInput from '@/Shared/Fields/VueSelectInput'
import TextareaInput from '@/Shared/Fields/TextareaInput'
import CepInput from '@/Shared/Fields/CepInput'
import EmailInput from '@/Shared/Fields/EmailInput'
import DateInput from '@/Shared/Fields/DateInput'
import SwitchInput from '@/Shared/Fields/SwitchInput'

import ExitWithoutModal from '@/Shared/Modal/ExitWithoutSaveModal/ExitWithoutModal.vue'

import axios from 'axios'

export default {
  components: {
    HeaderTitle,
    LoadingButton,
    SelectInput,
    TextInput,
    PasswordInput,
    MaskInput,
    PhotoInput,
    VueSelectInput,
    TextareaInput,
    CepInput,
    EmailInput,
    DateInput,
    SwitchInput,
    ExitWithoutModal,
  },
  layout: Layout,
  props: {
    profile: Object,
    specialties: Array,
    states_options: Object,
    class_entity_options: Object,
    sex_options: Object,
    certificates: Array,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },

  mounted() {
    this.routerListenerIdentification = router.on('before', event => {
      this.routerToNavigate = event.detail.visit.url

      if (this.form.isDirty && this.routerToNavigate.pathname !== '/profile') {
        event.preventDefault()
        this.$refs.confirmExitModal.openModal()
      }
    })
  },

  unmounted() {
    if (this.routerListenerIdentification)
      this.routerListenerIdentification()
  },

  data() {
    return {
      routerListenerIdentification: null,
      routerToNavigate: null,
      userCertificates: this.$props.certificates,
      changePassword: false,
      form: useForm({
        certificates: [],
        photo: {
          name: this.profile.photo?.name,
          size: this.profile.photo?.size,
          url: this.profile.photo?.url,
        },
        name: this.profile.name,
        email: this.profile.email,
        password: '',
        professional: this.profile.professional,
        specialties: this.profile.specialties ?? [],
      }),
    }
  },
  methods: {
    handlerAcceptExitOnPage() {
      this.$refs.confirmExitModal.closeModal()
      window.location.href = this.routerToNavigate
    },

    handlerDenyExitOnPage() {
      this.$refs.confirmExitModal.closeModal()
    },

    update() {
      this.form.post('/profile', {
        forceFormData: true,
        onSuccess: () => {
          this.userCertificates = this.$props.certificates
          this.changePassword = false
          this.form = useForm({
            photo: {
              name: this.profile.photo?.name,
              size: this.profile.photo?.size,
              url: this.profile.photo?.url,
            },
            name: this.profile.name,
            email: this.profile.email,
            password: '',
            professional: this.profile.professional,
            specialties: this.profile.specialties ?? [],
          })
        },
      })
    },

    handleRemoveUpload( index ) {
      this.form.certificates.splice( index, 1 )
    },

    handleUploadPdf: function (event) {
      this.form.certificates.push( ...event.target.files )
    },

    removeCertificateFromList(id) {
      const index = this.userCertificates.findIndex(certificate => certificate.id === id)

      if (index !== -1)
        this.userCertificates.splice(index, 1)
    },

    async deleteCertificate( id ) {

      try {
        const response = await axios.delete(`/profile/delete-certificate/${id}`)

        if (response.status === 200) {
          this.removeCertificateFromList(id)
          this.$toast.success(response.data.message)
        }
      }

      catch (err) {
        if (axios.isAxiosError(err)) {
          this.$toast.error(err.response.data.message)
          return
        }

        this.$toast.error('Erro ao deletar certificado')
      }
    },

    deleteAddress(professional, address) {
      professional.addresses.splice(professional.addresses.indexOf(address), 1)
    },
    onUpdateAddress(address, json) {
      address.city = json.localidade
      address.state = json.uf
      address.street = json.logradouro
      address.neighborhood = json.bairro
    },
  },
}
</script>
